export default __webpack_public_path__ + "static/media/myTeamPayroll-Mobile.8afca2e4.png";